export const REGEXP_DATE_AVEC_MOIS_JOUR_INCONNU =
    /^((00\/00)|((00|(0[1-9]|[1-2][0-9]|3[0-1]))\/(0[1-9]|1[0-2])))\/((19[0-9]{2})|2[0-9]{3})$/;
export const REGEXP_DATE_FR =
    /^(0[1-9]|[1-2][0-9]|3[0-1])\/(0[1-9]|1[0-2])\/((19[0-9]{2})|2[0-9]{3})$/;
export const REGEXP_DATE_AVEC_ANNEE = /^((19[0-9]{2})|2[0-9]{3})$/;
export const REGEXP_DATE_AVEC_JOUR_MOIS_ANNEE =
    /^((00\/00)|((0[1-9]|[1-2][0-9]|3[0-1])\/(0[1-9]|1[0-2])))\/((19[0-9]{2})|2[0-9]{3})$/;
export const REGEXP_EMAIL = /^[a-zA-Z0-9_.-]+@[a-z0-9_.-]+\.[a-z]{2,63}$/;
export const REGEXP_CODE_POSTAL = /^[0-9]{5}$/;
export const REGEXP_NOM_PRENOM = /^[A-Z '-]+$/;
export const REGEXP_LIEU = /^[A-Z0-9 '-]+$/;
export const TAILLE_CAPTCHA = 6;
export const REGEX_RGA = /^[a-zA-Z0-9]{5}$/;

// Codes postaux de Guyane autorises (SIAR-6256)
export const CODES_POSTAUX_GUYANE_AUTORISES = [
    '97300', // Cayenne
    '97310', // Kourou
    '97311', // Roura
    '97312', // Saint-Elie
    '97313', // Saint-Georges-de-l'Oyapock
    '97314', // Saul
    '97315', // Sinnamary
    '97316', // Papaichton
    '97317', // Apatou
    '97318', // Mana
    '97319', // Awala-Yalimapo
    '97320', // Saint-Laurent-du-Maroni
    '97330', // Camopi
    '97340', // Grand-Santi
    '97350', // Iracoubo
    '97351', // Matoury
    '97352', // Roura
    '97353', // Regina
    '97355', // Macouria
    '97356', // Montsinery-Tonnegrande
    '97360', // Mana
    '97370', // Maripasoula
    '97380', // Ouanary
    '97390', // Regina
];

// Codes postaux de Mayotte autorises (SIAR-6257)
export const CODES_POSTAUX_MAYOTTE_AUTORISES = [
    '97600', // Koungou, Mamoudzou
    '97615', // Dzaoudzi, Pamandzi
    '97620', // Boueni, Chirongui
    '97625', // Kani-Keli
    '97630', // Acoua, Mtsamboro
    '97640', // Sada
    '97650', // Bandraboua, M'Tsangamouji
    '97660', // Bandrele, Dembeni
    '97670', // Chiconi, Ouangani
    '97680', // Tsingoni
];

export const REGEXP_NUMERO_GUICHET_UNIQUE = /^[0-9]{14,}$/;

// Âges minimums pour la création de compte
export const AGE_MAJORITE = 18;
export const AGE_MINIMUM_CHASSEUR = 16;
export const AGE_MINIMUM_LICENCIE = 12;
